import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import {Card, Dropdown, Table, Loader, Popup, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {invoiceQueryStatus, pageSizes} from '../../../common/constants/lists';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import TablePaginator from '../../../common/components/tablePaginator';

class InvoiceQuery extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  onGenerateClick(element) {
    this.props.generateOrderNote(element.invoiceNumber);
  }

  onPageClick(value) {
    this.props.changeInvoicesListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeInvoicesListPageSize(data.value);
  }

  renderEditOption(invoice, providerId, status) {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.InvoiceQuery,
        scopes.See
      )
    ) {
      return null;
    }
    if (status !== 'I') {
      return null;
    }
    return (
      <Popup
        trigger={
          <Link to={`/carga/factura/${invoice}/proveedor/${providerId}`}>
            <Icon name='write' size='large' />
          </Link>
        }
        content='Editar'
        position='top center'
        inverted
      />
    );
  }

  renderCancelInvoiceOption(invoice, providerId) {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.InvoiceQuery,
        scopes.See
      )
    ) {
      return null;
    }

    return (
      <Popup
        trigger={
          <Link to={`/carga/factura/${invoice}/proveedor/${providerId}`}>
            <Icon name='close' size='large' />
          </Link>
        }
        content='Anular'
        position='top center'
        inverted
      />
    );
  }

  renderGenerateOrderNoteOption(element) {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.InvoiceQuery,
        scopes.Create
      )
    ) {
      return null;
    }

    return (
      <Popup
        trigger={
          <Icon
            name='file'
            color='blue'
            size='large'
            rotated='counterclockwise'
            onClick={() => this.onGenerateClick(element)}
          />
        }
        content='Generar nota de pedido'
        position='top right'
        inverted
      />
    );
  }

  renderInvoices() {
    const {loading, invoices} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!invoices.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={6}>
            No hay facturas que cumplan con los filtros ingresados
          </Table.Cell>
        </Table.Row>
      );
    }

    return invoices.map((element, index) => {
      const statusData = _.find(invoiceQueryStatus, {'value': element.status});
      const dateFormatted = moment(element.date).format(dateFormatShow);

      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.invoiceNumber}</Table.Cell>
          <Table.Cell textAlign='center'>{element.provider}</Table.Cell>
          <Table.Cell textAlign='center'>{element.importer}</Table.Cell>
          <Table.Cell textAlign='center'>{statusData.text}</Table.Cell>
          <Table.Cell textAlign='center'>{dateFormatted}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderEditOption(
              element.invoiceNumber,
              element.providerId,
              element.status
            )}
            {this.renderCancelInvoiceOption(
              element.invoiceNumber,
              element.providerId
            )}
            {this.renderGenerateOrderNoteOption(element)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderPagination() {
    const {invoicesCount, pageSize, pageNumber} = this.props;
    if (invoicesCount <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={invoicesCount}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <Card fluid raised className='primary-content'>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>
                    Factura No.
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                    Proveedor
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                    Importador
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                    Fecha Factura
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                    Acciones
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderInvoices()}</Table.Body>

          {this.renderPagination()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loadingDealers': state.dealer.loading,
    'dealers': state.dealer.list,
    'loadingProviders': state.provider.loading,
    'providers': state.provider.list,
    'loading': state.invoicesQuery.loading,
    'invoices': state.invoicesQuery.page,
    'invoicesCount': state.invoicesQuery.list.length,
    'pageNumber': state.invoicesQuery.pageNumber,
    'pageSize': state.invoicesQuery.pageSize,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'oderNoteUrl': state.invoicesQuery.oderNoteUrl,
  };
};

const {
  fetchDealers,
  loadProviders,
  fetchInvoices,
  clearInvoicesData,
  changeInvoicesListPage,
  changeInvoicesListPageSize,
  generateOrderNote,
  clearOrderNoteUrl,
} = Actions;

export default connect(mapStateToProps, {
  fetchDealers,
  loadProviders,
  fetchInvoices,
  clearInvoicesData,
  changeInvoicesListPage,
  changeInvoicesListPageSize,
  generateOrderNote,
  clearOrderNoteUrl,
})(InvoiceQuery);
